<template>
	<div class="line">
		<div class="line-left">
			<div class="bg1"></div>
		</div>
		<div ref="linechart" class="linechart" @mouseover="autoTimePaused = true" @mouseout="autoTimePaused = false">
		</div>
	</div>
</template>

<script>
import * as methods from "./method.js";
export default {
	name: "template.scope64",
	props: {
		vdata: {
			type: [Array, String],
			default: () => [],
		},
		jsondata: {
			type: [Array, String],
			default: () => [],
		},
		scopedata: {
			type: Object,
			default: () => { },
		},
	},
	data() {
		return {
			title: "scope64-【组件】玫瑰图图样式-完成",
			timer: null,
			defaultdata: [
				{ value1: "系列一", value2: "100", value3: "人" },
				{ value1: "系列二", value2: "200" },
				{ value1: "系列三", value2: "300" },
				{ value1: "系列四", value2: "400" },
				{ value1: "系列五", value2: "600" },
			],
			valueMap: [
				{ name: "名称", key: "value1" },
				{ name: "数值", key: "value2" },
				{ name: "单位", key: "value3" },
			],
			exceldata: [],
			apiconfig: {},
			isApi: false,
			scope: {},
			config: {},
			autoTimePaused: false,
		};
	},
	watch: {
        vdata(n) {
            if (n && n.length) {
                let vdatalist = n.filter(item => {
                    let vlist = Object.keys(item)
                    let isdata = false
                    vlist.forEach(del => {
                        if (item[del] == undefined) {
                            item[del] = ''
                        } else if (del && item[del]) {
                            isdata = true
                        }
                    })
                    if (vlist.length && isdata) return item
                })
				console.log('___vdatalist', this.vdatalist)
                this.defaultdata = vdatalist
            }
        },
		jsondata(n) {
			this.exceldata = n;
		},
		defaultdata(n) {
			this.DrawEcharts();
		},
	},
	beforeDestroy() {
		clearInterval(this.timer);
		this.timer = null;
	},
	methods: {
		...methods,
		DrawEcharts() {
			clearInterval(this.timer);
			this.timer = null;
			var echarts = require("echarts");
			var TmyChart = echarts.init(this.$refs.linechart);
			let colorData = ["#89a5c2", "#084f7b", "#8dcbf3", "#00ace1", "#008bfc", "#0070dc", "#01213f", "#004d91"];
			let chartlist = []
			console.log('___defaultdata', this.defaultdata)
			if (this.defaultdata.length > 10) {
				chartlist = JSON.parse(JSON.stringify(this.defaultdata)).slice(0, 10)
			} else {
				chartlist = JSON.parse(JSON.stringify(this.defaultdata))
			}
			let mydata = chartlist.map((item, i) => {
				return {
					name: item.value1,
					value: item.value2,
					itemStyle: { color: colorData[i] },
				};
			});
			let unit = this.defaultdata[0].value3;
			var Toption = {
				tooltip: {
					trigger: "item",
				},
				series: [
					{
						type: "pie",
						radius: [50, 100],
						// center: ["50%", "50%"],
						data: mydata
							.map((item) => item.value && item)
							.sort(function (a, b) {
								return b.value - a.value;
							}),
						roseType: "radius",
						label: {
							color: "#C6D2D8",
							fontSize: 12,
							alignTo: 'labelLine',
							formatter: function (params) {
								let newFor = `${params.data.name}\n${params.data.value}${unit}`;
								return newFor;
							},
							// minMargin: 50,
							// edgeDistance: 0,
							// lineHeight: 15,
						},
						labelLine: {
							lineStyle: {
								color: "#748496",
							},
						},
						animationType: "scale",
						animationEasing: "elasticOut",
						animationDelay: function (idx) {  //动画延迟
							return Math.random() * 200;
						},
					},
				],
			};
			console.log('__-series', Toption)
			TmyChart.clear();
			Toption && TmyChart.setOption(Toption);
			// this.timer = setInterval(() => {
			// 	if (this.autoTimePaused) return; // 如果定时器暂停，则不执行后续逻辑
			// 	TmyChart.clear();
			// 	Toption && TmyChart.setOption(Toption);
			// }, 5000);
		},
	},
	created() { },
	mounted() {
		if (this.vdata && this.vdata.length) {
			this.defaultdata = this.vdata;
		}
		if (this.jsondata && this.jsondata.length) {
			this.exceldata = this.jsondata;
		}
		this.setData()
		this.DrawEcharts(); //需要刷新的数据
	},
};
</script>

<style scoped>
.line {
	width: 435px;
	height: 240px;
	display: flex;
	position: relative;
	overflow: hidden;
	padding: 10px 0;
}

.line-left {
	width: 100%;
	height: 100%;
}

.line-left .bg1 {
	width: 86px;
	height: 86px;
	box-sizing: border-box;
	background: url("@/assets/pie-bg6.png") no-repeat;
	background-size: 100% 100%;
	position: absolute;
	top: calc(50% - 43px);
	left: calc(50% - 43px);
	z-index: 1;
	animation: rotates 3s linear infinite;
}
@keyframes rotates {
	from {
		transform: rotate(360deg);
	}
	to {
		transform: rotate(0deg);
	}
}

.linechart {
	width: 100%;
	height: 100%;
	position: absolute;
	top: 0px;
	z-index: 5;
}
</style>